<mat-card *ngIf="visibilityService.actionBarVisibility | async"><router-outlet name="action-bar"></router-outlet></mat-card>
